const BuyCourseActionTypes = {
	FETCH_PRODUCT_LIST: {
		SUCCESS: 'FETCH_PRODUCT_LIST_SUCCESS',
		FAILURE: 'FETCH_PRODUCT_LIST_FAILURE',
		PENDING: 'FETCH_PRODUCT_LIST_PENDING',
	},
	FETCH_PRODUCT_DETAILS: {
		SUCCESS: 'FETCH_PRODUCT_DETAILS_SUCCESS',
		FAILURE: 'FETCH_PRODUCT_DETAILS_FAILURE',
		PENDING: 'FETCH_PRODUCT_DETAILS_PENDING',
	},
	VALIDATE_COUPON: {
		SUCCESS: 'VALIDATE_COUPON_SUCCESS',
		FAILURE: 'VALIDATE_COUPON_FAILURE',
		PENDING: 'VALIDATE_COUPON_PENDING',
	},
	START_TRANSACTION: {
		SUCCESS: 'START_TRANSACTION_SUCCESS',
		FAILURE: 'START_TRANSACTION_FAILURE',
		PENDING: 'START_TRANSACTION_PENDING',
	},
	PROCESS_PAYMENT: {
		SUCCESS: 'PROCESS_PAYMENT_SUCCESS',
		FAILURE: 'PROCESS_PAYMENT_FAILURE',
		PENDING: 'PROCESS_PAYMENT_PENDING',
	},
	LOG_PAYMENT: {
		SUCCESS: 'LOG_PAYMENT_SUCCESS',
		FAILURE: 'LOG_PAYMENT_FAILURE',
		PENDING: 'LOG_PAYMENT_PENDING',
	},
	FETCH_RELATED_PRODUCTS: {
		SUCCESS: 'FETCH_RELATED_PRODUCTS_SUCCESS',
		FAILURE: 'FETCH_RELATED_PRODUCTS_FAILURE',
		PENDING: 'FETCH_RELATED_PRODUCTS_PENDING',
	},
	SET_CURRENT_PRODUCT_ID: 'SET_CURRENT_PRODUCT_ID',
	SET_COUPON: 'SET_COUPON',
	SET_API_COUNT: 'SET_API_COUNT',
	RESET_CHECKSUM: 'RESET_CHECKSUM',
	SET_PAY_METHOD: 'SET_PAY_METHOD',
	SHOW_PREVIEW_COURSES: 'SHOW_PREVIEW_COURSES',
};

export default BuyCourseActionTypes;
